var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38, _ellipse2, _ellipse3, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtc06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.189453,
    y: 0.285156,
    width: 350,
    height: 233,
    fill: "#4B4497"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.34 186.789C217.144 191.316 226.346 192.012 232.189 192.012C237.059 191.737 238.84 189.405 238.676 188.393C238.378 186.558 239.024 185.414 236.49 182.662C233.957 179.91 219.195 170.509 212.034 167.413C204.874 164.317 197.045 162.985 194.078 165.922C192.018 167.961 192.42 171.478 194.078 174.628C195.363 177.074 200.828 182.925 208.34 186.789Z",
    fill: "#10201C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.487 148.499C273.521 155.325 282.564 154.726 286.445 154.726C293.034 154.524 295.21 151.584 295.059 150.7C294.783 149.095 295.381 148.094 293.034 145.688C290.686 143.282 277.008 135.061 270.374 132.354L270.344 132.342C263.712 129.636 254.813 126.005 252.067 128.57C250.159 130.352 251.016 135.851 252.552 138.606C254.088 141.361 255.918 144.435 262.487 148.499Z",
    fill: "#10201C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.195 143.379C176.816 141.512 175.207 137.655 175.207 134.117C175.393 129.244 176.677 132.389 177.65 132.389C178.623 132.389 180.856 136.443 181.504 139.867C182.153 143.291 197.57 159.896 185.006 150.596C181.738 148.176 179.554 145.219 178.214 143.405L178.195 143.379Z",
    fill: "#10201C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.703 134.541C176.17 144.517 189.754 154.339 196.487 158.002L196.218 146.7C193.989 145.161 188.865 142.131 182.549 136.505C177.497 132.005 175.88 123.981 175.703 120.531V134.541Z",
    fill: "#B45B5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.507 158.021L196.229 146.977L198.338 145.445L198.453 156.213L196.507 158.021Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 156.217L196.656 148.569L198.011 147.461L198.115 155.065L196.843 156.217Z",
    fill: "#A3A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.843 156.214L196.656 148.566L203.034 152.132L202.136 159.176L196.843 156.214Z",
    fill: "#D07D7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.82 144.824C291.636 146.069 291.797 149.03 290.818 151.313",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.568 145.941C292.93 146.709 293.437 148.776 292.568 150.907",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.92 138.938C304.086 139.142 306.228 140.28 305.466 143.19",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.492 140.824C304.789 141.111 305.294 142.119 304.938 143.855",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.326 128.045C305.812 127.807 306.914 127.361 307.437 127.481",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.771 126.648C306.009 126.519 306.591 126.261 307.019 126.262",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M301.709 132.583C302.296 132.382 303.622 132.1 304.227 132.583",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.854 131.776C302.062 131.589 302.822 131.206 304.195 131.168",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M275.245 112.17C275.254 111.317 275.085 109.348 274.334 108.301",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M275.754 112.026C275.934 111.068 276.084 108.771 275.242 107.246",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M291.822 116.417C291.987 115.682 292.586 114.096 293.665 113.629",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.389 116.97C292.602 116.253 293.399 114.624 294.877 113.84",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.783 188.788C242.5 188.99 241.644 189.208 240.48 188.465",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M243.56 188.124C243.289 188.271 242.597 188.421 242 187.852",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M249.499 176.758C249.092 176.86 247.884 177.002 246.311 176.758",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M249.599 175.945C249.17 176.058 248.047 176.216 246.988 175.945",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242.672 182.965C242.927 183.407 243.697 184.335 244.739 184.515",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.92 182.449C243.07 182.809 243.607 183.559 244.56 183.685",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M223.564 141.395C218.849 140.896 214.944 143.683 213.58 145.139C217.416 157.503 222.541 183.247 223.095 187.075C223.789 191.859 238.497 192.869 242.726 188.986C246.175 186.182 249.401 180.764 249.911 173.635C250.327 167.814 246.86 157.411 241.314 151.171C235.767 144.931 229.457 142.018 223.564 141.395Z",
    fill: "#141414"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M215.07 144.105C213.027 144.613 212.885 145.911 212.221 146.763C218.649 161.124 230.461 189.698 232.566 190.36C235.197 191.187 241.196 187.618 243.234 181.105C245.065 176.067 244.176 169.151 242.619 164.904C239.61 156.699 233.498 149.756 227.486 146.278C221.36 142.734 215.976 143.88 215.07 144.105Z",
    fill: "#D68585"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M213.613 144.788L204.68 150.273C204.597 158.098 205.821 175.199 211.381 180.994C218.331 188.238 224.351 189.853 229.588 190.685C234.825 191.517 238.137 187.857 239.126 186.671L239.154 186.637C240.558 184.953 244.135 180.665 242.99 170.632C240.281 158.132 232.345 150.865 226.827 147.322C221.938 144.183 216.051 144.151 213.613 144.788Z",
    fill: "#B45B5B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.112 152.172L196.656 148.569L198.011 147.461L204.385 151.02L203.112 152.172Z",
    fill: "#FFC8C8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M258.303 122.109L258.301 107.507L260.13 105.633L260.133 120.383L258.303 122.109Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.564 119.276C186.915 123.761 182.601 131.452 183.599 135.572C180.345 132.31 179.151 130.68 178.836 129.159C177.839 125.616 175.93 119.691 180.716 114.841C186.699 108.78 193.911 105.123 204.724 102.57C213.817 100.423 226.16 99.6045 237.885 101.195C247.416 102.488 255.914 105.438 258.302 107.196V121.966C254.932 120.872 251.676 119.248 235.932 115.863C220.187 112.479 205.779 113.978 195.564 119.276Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M209.411 148.702C200.526 149.206 200.202 159.269 200.79 164.344C201.797 169.924 204.559 174.036 207.733 177.858C217.825 189.488 227.113 187.597 229.213 186.501C231.435 185.34 236.823 180.409 235.338 172.111C234.197 165.734 228.728 158.952 226.36 156.547C223.951 154.099 217.654 148.235 209.411 148.702Z",
    fill: "#B45B5B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.69 153.877C200.494 154.021 200.78 162.562 202.072 166.815C205.228 176.058 213.397 182.448 216.632 183.853C220.308 185.449 228.127 185.07 229.975 179.751C231.823 174.431 229.502 169.325 229.065 168.363C228.841 167.871 221.185 153.697 209.69 153.877Z",
    fill: "#D68585"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.079 112.907L258.623 109.304L259.978 108.195L266.352 111.755L265.079 112.907Z",
    fill: "#FFC8C8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.809 119.522L258.623 109.305L265.001 112.871L264.103 122.484L258.809 119.522Z",
    fill: "#D07D7D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.355 145.441L196.227 146.972C184.338 140.875 178.869 133.651 176.96 128.524C173.402 118.976 178.444 114.213 181.409 111.454C184.824 108.005 194.666 101.305 208.431 99.519C215.702 98.5756 221.496 98.0169 229.997 98.513C246.793 99.7674 257.074 103.773 260.123 105.631L258.28 107.52C256.329 106.405 249.277 104.108 245.85 103.333C240.773 102.279 228.159 100.357 218.318 101.107C206.016 102.044 200.671 103.51 198.328 104.447C195.984 105.384 189.625 107.337 184.431 111.789C179.775 115.78 178.542 118.125 178.18 120.498C177.042 132.309 191.574 142.149 198.355 145.441Z",
    fill: "#FFC8C8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M252.979 130.374C252.869 129.219 253.895 125.633 254.422 123.984L256.003 126.939L263.286 138.139C268.234 141.117 278.184 147.113 278.403 147.278C278.623 147.443 291.23 146.706 297.506 146.316C300.415 144.209 305.985 140.682 304.996 143.43C303.759 146.866 298.537 154.974 283.351 154.356C268.165 153.737 259.974 145.297 256.742 140.936C253.714 136.849 253.117 131.818 252.979 130.374Z",
    fill: "#B45B5B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.069,
    cy: 129.051,
    rx: 28.4641,
    ry: 21.3281,
    transform: "rotate(22.8984 281.069 129.051)",
    fill: "#141414"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M262.883 142.38C263.001 141.6 263.465 139.854 264.373 139.117",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 281.599,
    cy: 125.5,
    rx: 13.3575,
    ry: 8.11767,
    transform: "rotate(22.8984 281.599 125.5)",
    fill: "#AB5050"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.927,
    cy: 127.338,
    rx: 11.4173,
    ry: 6.93854,
    transform: "rotate(22.8984 282.927 127.338)",
    fill: "#141414"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.209 136.97C288.365 141.26 298.712 139.734 301.319 133.562C303.926 127.39 297.806 118.909 287.65 114.619C277.494 110.329 267.147 111.855 264.54 118.027C261.933 124.199 268.053 132.68 278.209 136.97ZM280.229 132.188C286.038 134.642 291.956 133.769 293.447 130.239C294.938 126.709 291.438 121.858 285.629 119.405C279.82 116.951 273.903 117.824 272.412 121.354C270.921 124.884 274.421 129.735 280.229 132.188Z",
    fill: "#D68585"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M253.783 126.764C254.083 125.599 255.141 123.068 256.975 122.262",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.336 129.468C254.478 128.427 255.052 126.204 256.216 125.637",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261.998 141.672C262.246 140.395 263.261 137.451 265.332 135.891",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M261.164 140.875C261.23 139.661 261.849 137.006 263.797 136.102",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M278.186 137.035C278.207 137.865 278.035 139.808 277.178 140.943",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M278.98 137.383C279.075 137.719 279.207 138.581 278.98 139.337",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M236.428 146.754C236.071 146.804 235.303 147.064 235.082 147.701",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M235.845 146.281C235.293 146.471 234.075 147.049 233.621 147.844",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M245.893 158.605C245.473 158.734 244.391 159.137 243.422 159.719",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M246.367 159.227C246.044 159.335 245.261 159.656 244.711 160.076",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220.851 143.789C220.807 143.375 220.951 142.437 221.882 141.992",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M221.379 143.95C221.406 143.641 221.591 142.96 222.12 142.707",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M229.338 147.305C229.461 146.935 229.861 146.168 230.475 146.062",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.193 156.242C238.493 155.846 239.288 155.022 240.07 154.895",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.404 156.56C238.686 156.277 239.367 155.681 239.832 155.555",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.455 166.218L208.918 161.328L210.836 162.686C211.947 163.473 212.1 164.611 211.419 165.573C210.728 166.549 209.603 166.762 208.475 165.963L207.597 165.342L206.469 166.936L205.455 166.218ZM208.176 164.524L208.892 165.031C209.493 165.457 210.026 165.327 210.372 164.832C210.72 164.348 210.658 163.812 210.059 163.383L209.343 162.876L208.176 164.524Z",
    fill: "#EDAFAF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.06 169.57C209.742 169.345 209.665 168.91 209.894 168.6C210.107 168.285 210.543 168.213 210.858 168.442C211.161 168.651 211.242 169.088 211.022 169.399C210.8 169.713 210.36 169.782 210.06 169.57Z",
    fill: "#EDAFAF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M211.487 170.489L214.95 165.599L216.868 166.957C217.979 167.744 218.132 168.881 217.451 169.844C216.76 170.82 215.635 171.033 214.507 170.234L213.629 169.613L212.5 171.207L211.487 170.489ZM214.208 168.795L214.924 169.302C215.525 169.728 216.058 169.598 216.404 169.103C216.751 168.619 216.689 168.083 216.091 167.654L215.375 167.147L214.208 168.795Z",
    fill: "#EDAFAF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M220.239 169.344L216.776 174.234L215.776 173.526L219.239 168.636L220.239 169.344Z",
    fill: "#EDAFAF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.162 176.035C218.04 175.235 217.865 174.021 218.691 172.862C219.488 171.728 220.73 171.456 221.804 172.217C222.767 172.898 223.096 174.044 222.212 175.294L222.011 175.577L219.505 173.803C219.113 174.357 219.199 174.93 219.713 175.299C220.056 175.537 220.405 175.561 220.658 175.411L221.611 176.085C220.988 176.664 220.069 176.672 219.162 176.035ZM219.95 173.175L221.51 174.28C221.822 173.832 221.742 173.293 221.294 172.981C220.837 172.652 220.269 172.767 219.95 173.175Z",
    fill: "#EDAFAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc06);
export default __webpack_public_path__ + "static/media/etc_06.ef49a0f3d7419ca91c6e72a1b3414aad.svg";
export { ForwardRef as ReactComponent };